import EloquaActions from '../actions/eloqua';

const initialState = {
    eloquaInflight: false,
    eloquaSuccess: false,
    eloquaFail: false
};

export default (state = initialState, action) => {
    switch (action.type) {
    case EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_START:
        return { ...state, eloquaInflight: true };
    case EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS:
        return {
            ...state,
            eloquaInflight: false,
            eloquaSuccess: true,
            eloquaFail: false
        };
    case EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_FAIL:
        return {
            ...state,
            eloquaInflight: false,
            eloquaSuccess: false,
            eloquaFail: true
        };
    default:
        return state;
    }
};
